import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=f72c99e8&scoped=true&"
import script from "./DropdownSelect.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DropdownSelect.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DropdownSelect.vue?vue&type=style&index=0&id=f72c99e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72c99e8",
  null
  
)

export default component.exports